import { AdvancedMarker } from "@vis.gl/react-google-maps";
import { Company } from "models/Company";
import CompanyInfo from "./CompanyInfo";
import Dot from "features/maps/Dot";
import { useMemo } from "react";

const CompanyStateColors: Record<string, string> = {
  ACTIVE: "#2f6ae1",
  NEW: "#1aad1a",
  ARCHIVED: "#dba100",
  BLOCKED: "hsl(0, 68%, 62%)",
};

type CompanyMarkerProps = {
  company: Company;
  isSelected: boolean;
  onSelect: () => void;
  onClose: () => void;
  route?: google.maps.routes.Route | null;
};

const CompanyMarker: React.FC<CompanyMarkerProps> = (props) => {
  const { company, isSelected, onSelect, onClose, route } = props;

  const routeInfo = useMemo(() => {
    if (!route) return null;

    const distance = Math.round((route.legs?.[0]?.distanceMeters || 0) / 1000);
    const durationInSeconds = (route.legs?.[0]?.durationMillis || 0) / 1000;
    const hours = Math.floor(durationInSeconds / 3600);
    const minutes = Math.floor((durationInSeconds % 3600) / 60);

    return { kilometers: distance, duration: { hours, minutes } };
  }, [route]);

  return (
    <AdvancedMarker position={{ lat: company.latitude, lng: company.longitude }} onClick={onSelect}>
      <Dot selected={isSelected} color={CompanyStateColors[company.state]} />

      {isSelected && <CompanyInfo company={company} routeInfo={routeInfo} onClose={onClose} />}
    </AdvancedMarker>
  );
};

export default CompanyMarker;
